import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';
import { FileDownloadService } from '../../../services/file-download-service.service';

/**
 * Injectable
 */
@Injectable({
  providedIn: 'root'
})
export class FileAttachmentService {
  /**
   * Constructor
   */
  constructor(private httpClient: HttpClient, private fileDownloadService: FileDownloadService, private appServiceHelper: AppServiceHelperService) { }

  /**
   * Retrieves the valuation event attachments list
   * @param oid Valuation event Oid
   * @returns List of attachments
   */
  getValuationEventAttachments(oid: number): Observable<any> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ValuationPortfolios/attachments?oid=${oid}`)).pipe(take(1));
  }

  /**
   * Retrieves the attachments list for a property and associated portfolio
   * @param propertyId Property id
   * @param valuationId Valuation Portfolio id
   * @returns List of attachments
   */
  getReportAttachments(propertyId: number, valuationId: number): Observable<any> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Reports/attachments?propertyId=${propertyId}&valuationPortfolioId=${valuationId}`)).pipe(take(1));
  }

  /**
   * Initiate download of a valuation event attachment
   * @param oid Attachment Oid
   */
  initiateDownloadValuationEventAttachment(oid: number): void {
    const url = this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ValuationPortfolios/attachment?oid=${oid}`);
    this.fileDownloadService.initiateDownload(url, null, false);
  }

  /**
   * Initiate download of a report attachment
   * @param oid Attachment Oid
   */
  initiateDownloadReportAttachment(oid: number): void {
    const url = this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Reports/attachment?oid=${oid}`);
    this.fileDownloadService.initiateDownload(url, null, false);
  }
}
